import { OPEN_AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';

export default function isAuthEditRequested(lineage = []) {
  return lineage.some((auth) => (
    OPEN_AUTHORIZATION_STATUSES.some((openState) => auth.state === openState)));
}
